const seoConfig = {
  '/': {
    title: 'DAAT Global | African Design, Art, Architecture & Technology',
    description: 'A dynamic intersection of Design, Art, Architecture and Technology rooted in the timeless expression of Africa\'s rich cultural heritage.',
    canonical: 'https://daatglobal.com/',
  },
  '/vision': {
    title: 'DAAT Vision | African Heritage In Global Design',
    description: 'DAAT Vision harnesses African heritage to drive global design innovation. Explore our projects and learn how culture shapes spaces, systems, and stories.',
    canonical: 'https://daatglobal.com/vision',
  },
  '/connect': {
    title: 'DAAT Connect | Activating Africa\'s Cultural Intelligence in Design',
    description: 'Connect with DAAT to explore spaces, shapes & stories. Discover our projects and collaborative process that create cultural impact and innovation.',
    canonical: 'https://daatglobal.com/connect',
  },
  '/spaces': {
    title: 'DAAT Spaces | Global Architecture Shaped by African Design & Culture',
    description: 'Explore DAAT Spaces, where African design systems shape global architecture, hospitality, and cultural landmarks. Discover tradition and innovation built together.',
    canonical: 'https://daatglobal.com/spaces',
  },
  '/partner': {
    title: 'DAAT Partners | Co-Creating with Experts in Design & Heritage',
    description: 'Partner with DAAT to co-create spaces and stories rooted in Africa\'s traditions. Access global networks and collaborations that drive global innovation.',
    canonical: 'https://daatglobal.com/partner',
  },
  '/mavericks': {
    title: 'JALI Maverick | Global Thought Leaders Shaping Culture And Innovation',
    description: 'Explore the thinkers, creators, and leaders who shape global creativity and drive transformative cultural innovation.',
    canonical: 'https://daatglobal.com/mavericks',
  },
  '/jali': {
    title: 'JALI Stories | A Tribute to the Timeless Art of Storytelling',
    description: 'Experience JALI, a living channel of African narrative, symbolic thinking, and creative knowledge. Explore how story becomes structure and voice becomes vision.',
    canonical: 'https://daatglobal.com/jali',
  },
  '/jali-stories': {
    title: 'JALI Stories | A Living Archive of African Design & Global Voices',
    description: 'Step into JALI Stories, a living archive of African design, heritage and storytelling, unveiling the global voices beneath the structures that shape our world.',
    canonical: 'https://daatglobal.com/jali-stories',
  },
  '/guardians': {
    title: 'DAAT Guardians | African Pioneers Whose Legacy Shaped Global Design',
    description: 'Step into a tribute to African pioneers shaping global design, art, and architecture. Discover minds whose contributions drive cultural innovation.',
    canonical: 'https://daatglobal.com/guardians',
  },
  '/experts': {
    title: 'JALI Experts | African Design Leaders in Global Innovation & Heritage',
    description: 'Meet the African design experts shaping global architecture, heritage, and tech through Africa\'s timeless heritage and creative innovation.',
    canonical: 'https://daatglobal.com/experts',
  },
  '/discover': {
    title: 'Discover DAAT: Design, Art, Architecture & Technology',
    description: 'Explore DAAT, where design, art, architecture, and technology meet Africa\'s cultural intelligence to shape innovation and timeless creations.',
    canonical: 'https://daatglobal.com/discover',
  },
  '/discover/design': {
    title: 'DAAT Design | Blending African Tradition with Global Innovation',
    description: 'Explore how African material language and form as storytelling shape modern design. Discover DAAT\'s design philosophy rooted in heritage.',
    canonical: 'https://daatglobal.com/discover/design',
  },
  '/discover/art': {
    title: 'DAAT Art | African Creativity in Modern Global Expression',
    description: 'Discover contemporary African voices and art as cultural memory. Explore how DAAT\'s art practice bridges heritage and modern expression.',
    canonical: 'https://daatglobal.com/discover/art',
  },
  '/discover/architecture': {
    title: 'DAAT Architecture | African Wisdom Shaping Structures for the Future',
    description: 'Explore sustainable materials, urban planning for cultural continuity, and vernacular forms rooted in African heritage shaping global architecture.',
    canonical: 'https://daatglobal.com/discover/architecture',
  },
  '/discover/technology': {
    title: 'DAAT Technology | From Ancient African Fire to Digital Innovation',
    description: 'Discover how DAAT bridges generations of African craftsmanship with digital innovation, preserving heritage while building pathways for the future.',
    canonical: 'https://daatglobal.com/discover/technology',
  },
  '/articles': {
    title: 'DAAT Articles | African Heritage, Global Design & Innovative Systems',
    description: 'Explore DAAT\'s Articles, where African design, cultural knowledge, and creative traditions meet. Discover perspectives shaping global design.',
    canonical: 'https://daatglobal.com/articles',
  },
  '/events': {
    title: 'DAAT Events | African Design & Cultural Events Worldwide',
    description: 'Discover DAAT events celebrating African design, art, architecture and technology. Join conversations shaping the future of African cultural innovation.',
    canonical: 'https://daatglobal.com/events',
  },
  '/press': {
    title: 'DAAT Press | African Design & Heritage in Global Media',
    description: 'Explore DAAT in the press. Read about our impact on global design, African heritage, and cultural innovation across international publications.',
    canonical: 'https://daatglobal.com/press',
  },
  '/careers': {
    title: 'DAAT Careers | Join Africa\'s Leading Design & Heritage Platform',
    description: 'Join the DAAT team. Explore career opportunities at the intersection of African design, art, architecture, technology and cultural innovation.',
    canonical: 'https://daatglobal.com/careers',
  },
  '/contact': {
    title: 'Contact DAAT Global | African Design & Heritage Platform',
    description: 'Get in touch with DAAT Global. Connect with our team to explore partnerships, collaborations, and opportunities in African design and heritage.',
    canonical: 'https://daatglobal.com/contact',
  },
};

export default seoConfig;